import { render, staticRenderFns } from "./delete-dialog.vue?vue&type=template&id=52c28e92"
import script from "./delete-dialog.vue?vue&type=script&lang=ts"
export * from "./delete-dialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports